var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 29,
    viewBox: "0 0 15 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\xA6\x86 icon \"Facebook F\""
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.8682 16.0468L14.6378 11.032H9.826V7.77779C9.826 6.40586 10.4982 5.06855 12.6532 5.06855H14.8407V0.799041C14.8407 0.799041 12.8556 0.460251 10.9576 0.460251C6.99499 0.460251 4.40481 2.86209 4.40481 7.21008V11.032H0V16.0468H4.40481V28.1696H9.826V16.0468H13.8682Z",
    fill: "#EAEAEA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFacebook);
export default __webpack_public_path__ + "static/media/icoFacebook.b5a88e6a91c84e1aa5ae291ec7335f35.svg";
export { ForwardRef as ReactComponent };